import React from 'react'
import {
    BackButton,
    BlocCheckBox,
    BlocTextField,
    BlocPhoneNumber,
    Button,
    Conditionnal,
    Header,
    ProgressBar,
} from '../ImportAll'

export default function Vue16() {
    return (
        <div>
            <Header
                title="J'estime mon prêt"
                subTitle="Information de contact estimation"
            />
            <div className="Container">
                <div className="BackNavigationContainerLeft">
                    <BackButton />
                </div>
            </div>
            <div className="Container">
                <ProgressBar size={100} time={1} />
            </div>
            <div className="Container">
                <BlocTextField
                    key="key146"
                    nbcolumn={1}
                    linked_data_id="contact_nom"
                    label="Nom"
                    placeholder="Votre nom"
                />
                <BlocTextField
                    key="key147"
                    nbcolumn={1}
                    linked_data_id="contact_prenom"
                    label="Prénom"
                    placeholder="Votre prénom"
                />
                <BlocPhoneNumber
                    key="key148"
                    nbcolumn={1}
                    linked_data_id="contact_mobile"
                    label="Numéro de téléphone"
                    placeholder="Votre numéro de téléphone mobile"
                    messageErreur="Numéro invalide"
                    infobulle="Votre numéro doit prendre en compte l'indicatif. Pour cela le premier chiffre '0' ne doit pas étre entré.
                    <br/>
                    Par exemple, un numéro de téléphone '01 23 45 67 89' sera indiqué de la forme '+33 1 23 45 67 89'"
                />
                <BlocTextField
                    key="key149"
                    nbcolumn={1}
                    linked_data_id="contact_mail"
                    label="E-mail de contact"
                    placeholder="Votre E-mail de contact"
                    checkedByRegex={
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    }
                    messageErreur="Adresse mail invalide"
                    removeEspace
                />
                {process.env.REACT_APP_CODE_PROMO === 'true' && (
                    <BlocTextField
                        key="key160"
                        nbcolumn={1}
                        linked_data_id="code_promo"
                        label="Avez-vous un code promotionnel ?"
                        placeholder="Code promotionnel"
                        removeEspace
                    />
                )}
                <BlocCheckBox key="key189" rgpd linked_data_id="rgpd_accord" />

                <Conditionnal
                    linked_data_id="tech_immo_id_apporteur"
                    isNotEmpty
                >
                    <BlocCheckBox
                        key="key191"
                        rgpd_part
                        linked_data_id="rgpd_part_accord"
                    />
                </Conditionnal>

                <BlocCheckBox
                    key="key193"
                    demarche_mec
                    linked_data_id="demarchage_mec_accord"
                />

                <BlocCheckBox
                    key="key196"
                    demarche_part
                    linked_data_id="demarchage_part_accord"
                    infobulle="Les partenaires à qui nous pourrons transmettre vos données personnelles afin qu'ils puissent vous conseiller sont :
                            <ul class='infobullePartenaires'>
                                <li><b>Assuréa</b> - CS 10019 Rond-Point du Canet 13590 MEYREUIL - RCS Aix en Provence 447 731 787</li>
                                <li><b>Avantages Finances</b> - 1 PL DE LA MAIRIE 35530 NOYAL-SUR-VILAINE - RCS Rennes 822.875.365 - Immatriculé à l'ORIAS sous le numéro 17001976</li>
                                <li><b>Budgetlyss M.D</b> - 53 RUE JULES VALLES 35000 RENNES - Rennes B 493.389.415 - Immatriculé à l'ORIAS sous le numéro 13004876</li>
                                <li><b>Hestia</b> - 65 RUE DE LA CROIX 92000 NANTERRE - Nanterre B 915.371.389</li>
                                <li><b>Metlife</b> - 5 Place de la Pyramide 92800 PUTEAUX - RCS Nanterre 799 036 710</li>
                                <li><b>Sezame</b> - 24 RUE DES DAMES 75017 PARIS - Paris B 918.508.060</li>
                            </ul>
                        "
                />
            </div>

            <Conditionnal linked_data_id="contact_nom" isNotEmpty>
                <Conditionnal linked_data_id="contact_prenom" isNotEmpty>
                    <Conditionnal
                        linked_data_id="contact_mobile_validated"
                        isEqualTo
                        targetDataValueCompare={true}
                    >
                        <Conditionnal
                            linked_data_id="contact_mail_validated"
                            isEqualTo
                            targetDataValueCompare={true}
                        >
                            <Conditionnal
                                linked_data_id="rgpd_accord"
                                isEqualTo
                                targetDataValueCompare={true}
                            >
                                <Conditionnal
                                    linked_data_id="tech_immo_id_apporteur"
                                    isEmpty
                                >
                                    <div className="SubmitButtonContainer">
                                        <Button text="Suivant" EnrDossier />
                                    </div>
                                </Conditionnal>
                                <Conditionnal
                                    linked_data_id="tech_immo_id_apporteur"
                                    isNotEmpty
                                >
                                    <Conditionnal
                                        linked_data_id="tech_part_esquive_rgpd_part_tunnel_possible"
                                        isEqualTo
                                        targetDataValueCompare={true}
                                    >
                                        <div className="SubmitButtonContainer">
                                            <Button text="Suivant" EnrDossier />
                                        </div>
                                    </Conditionnal>

                                    <Conditionnal
                                        linked_data_id="tech_part_esquive_rgpd_part_tunnel_possible"
                                        isEqualTo
                                        targetDataValueCompare={false}
                                    >
                                        <Conditionnal
                                            linked_data_id="rgpd_part_accord"
                                            isEqualTo
                                            targetDataValueCompare={true}
                                        >
                                            <div className="SubmitButtonContainer">
                                                <Button
                                                    text="Suivant"
                                                    EnrDossier
                                                />
                                            </div>
                                        </Conditionnal>
                                    </Conditionnal>
                                </Conditionnal>
                            </Conditionnal>
                        </Conditionnal>
                    </Conditionnal>
                </Conditionnal>
            </Conditionnal>
        </div>
    )
}
